import React, { useState } from "react";
import { VLE } from "@unicef/shared-resources/models/db";
import usePromise from "./usePromise";
import { getCookieObject } from "../cookie";
import { services } from "../../services";
import { setAccessToken } from "../../services/request";

export type AuthState = { is_authenticated: boolean } & Partial<{
  access_token: string;
  vle: Pick<VLE, "id" | "cscId" | "email">;
}>;

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>({
    is_authenticated: false,
  });

  usePromise(
    {
      fn: async () => {
        const { access_token: accessToken } = getCookieObject();
        const cookieValidationResponse = await services.requestSvc
          .get<{
            id: number;
            cscId: string;
            email: string;
            name: string;
          }>("/validate-token", {
            // headers: { Authorization: "Bearer " + accessToken },
            withCredentials: true,
          })
          .catch(console.error);

        if (cookieValidationResponse) {
          setAuthState({
            is_authenticated: true,
            access_token: accessToken,
            vle: {
              id: BigInt(cookieValidationResponse.id),
              email: cookieValidationResponse.email,
              cscId: cookieValidationResponse.cscId,
            },
          });
          setAccessToken(accessToken);
        } else {
          setAuthState({
            is_authenticated: false,
            access_token: undefined,
            vle: undefined,
          });
          setAccessToken();
        }
      },
      runOnMount: { args: [] },
    },
    []
  );

  return authState;
}
